module.exports = __webpack_public_path__ + "static/media/spider-movie-app.7759343c.png";